import constants from '../constants'

const initialConstructionsState = {
  showWindow: false,
  formData: {
    name: '',
    phone: ''
  },
  formErrors: []
};

const constructionsReducer = function(state = initialConstructionsState, action) {
  switch(action.type) {
    case constants.ACTIONS.UPDATE_ORDER_CALL_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.payload
        }
      };

    case constants.ACTIONS.OPEN_ORDER_CALL_WINDOW:
      return {
        ...state,
        showWindow: true
      };

    case constants.ACTIONS.CLOSE_ORDER_CALL_WINDOW:
      return {
        ...state,
        showWindow: false
      };

    case constants.ACTIONS.ORDER_CALL_CLEAR_ERRORS:
      return {
        ...state,
        formErrors: []
      };
    case constants.ACTIONS.ORDER_CALL_ADD_ERROR:
      var errors = state.formErrors;
      errors.push(action.payload);
      return {
        ...state,
        formErrors: state.formErrors
      };

    case constants.ACTIONS.ORDER_CALL_REMOVE_ERROR:
      var errors = state.formErrors.filter(error => error != action.payload);

      return {
        ...state,
        formErrors: errors
      };
  }

  return state;
};
export default constructionsReducer;


// WEBPACK FOOTER //
// ./app/javascript/app/reducers/order_call.js